module.exports = __webpack_public_path__ + "media/images/profile_with_status_img-2d485c03cccf87ca04663d427d72af96.svg";